import { string } from 'fp-ts';
import { useCallback } from 'react';
import { pipe } from 'fp-ts/function';
import { Clickable, Icon, IconName, NestedCard, Stack, StackItem } from '@optimus-web/core';
import { LocalizedText, useAPI } from '@mews/framework';
import { oaky } from '@mews-commander/assets';
import { TextKey } from '@mews-commander/enums';
import { MewsImage } from '@mews/business-components';
import { openInBrowserTab, useCommanderThunkDispatch } from '@mews-commander/utils';
import { fetchOakyUpsellUrl } from './actions';

interface Props {
    reservationId: string;
}

const Upsell = ({ reservationId }: Props) => {
    const dispatch = useCommanderThunkDispatch();
    const fetchUrl = useCallback(async () => dispatch(fetchOakyUpsellUrl(reservationId)), [dispatch, reservationId]);

    const {
        data: { url },
    } = useAPI(fetchUrl, { url: null });

    if (url === undefined || url === null) {
        return null;
    }

    const sanitazedUrl = pipe(
        url,
        // prettier-ignore
        // eslint-disable-next-line no-useless-escape
        string.replace('{\"url\":\"', ''),
        // prettier-ignore
        // eslint-disable-next-line no-useless-escape
        string.replace('\"}', ''),
        string.replace('\\/', '/'),
        string.replace('\\/', '/'),
        string.replace('\\/', '/')
    );

    return (
        <Clickable onClick={() => openInBrowserTab(sanitazedUrl)} data-test-upsell-button>
            <NestedCard>
                <Stack spacing="100" itemAlignment="center">
                    <MewsImage src={oaky} width="40px" />
                    <StackItem grow>
                        <LocalizedText textKey={TextKey.ReservationUpsellAvailable} />
                    </StackItem>
                    <Icon value={IconName.ArrowRight} size="small" />
                </Stack>
            </NestedCard>
        </Clickable>
    );
};

export default Upsell;
